module.exports = __webpack_public_path__ + "static/media/CTLA_8-216w.d6141719.webp";